import React, { FunctionComponent } from "react";
import { CheckboxField, FieldSpy, Stack } from "@bps/fluent-ui";
import { FormPinField } from "@components/form/fields/FormPinField";

export const RedirectLinkField: FunctionComponent = () => {
  return (
    <Stack tokens={{ childrenGap: 8 }}>
      <CheckboxField name="usePin" label="Require PIN code" />
      <FieldSpy<string | undefined> name="usePin">
        {usePin => {
          if (!usePin) return null;
          return (
            <FormPinField
              name="pin"
              description="Leave blank to get an automatically generated code."
            />
          );
        }}
      </FieldSpy>
    </Stack>
  );
};
